import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useState } from 'react';
import { Slide } from '@mui/material';
import { WidgetContext } from '../../App';
import { ArticleArrowIcon } from '../OpenArticleIcon';
import { ArticleFiles } from './ArticleFiles';
import * as styles from './ArticlePage.module.css';
export const ArticlePage = ({ articleId, arrowColor, setArticleId, }) => {
    const { api } = useContext(WidgetContext);
    const [showAnimation, setShowAnimation] = useState(false);
    const [article, setArticle] = useState(null);
    /** Позволяет открывать любые ссылки из статьи в новой вкладке, а не внутри iframe */
    const onLinkClick = useCallback((event) => {
        event.preventDefault();
        const target = event.currentTarget;
        window.open(target.href, '_blank');
    }, []);
    useEffect(() => {
        const links = document.querySelectorAll('a');
        links.forEach((link) => link.addEventListener('click', onLinkClick));
        return () => links.forEach((link) => link.removeEventListener('click', onLinkClick));
    }, [article, onLinkClick]);
    useEffect(() => {
        if (!api)
            return;
        api.getArticle(articleId).then((res) => {
            setArticle(res);
            setShowAnimation(true);
        });
    }, [api, articleId]);
    const onArticleHeader = () => {
        setShowAnimation(false);
        setTimeout(() => setArticleId(null), 300);
    };
    return (_jsx("div", { className: styles.articlePageWrapper, children: article && (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.articlePageHeader, onClick: onArticleHeader, children: [_jsx("div", { children: _jsx(ArticleArrowIcon, { color: arrowColor }) }), _jsx("span", { title: article.title, children: article.title })] }), _jsx(Slide, { direction: 'left', in: showAnimation, children: _jsxs("div", { children: [_jsx("div", { className: styles.articleContent, dangerouslySetInnerHTML: { __html: article.content } }), _jsx(ArticleFiles, { files: article.files })] }) })] })) }));
};
